import React from 'react';
import { IQuestion, IQuestionAnswer } from '@/components/staffer/Grading/types';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import BaseCard from './BaseCard';
import BaseQuestionModeCard from './BaseQuestionModeCard';
import styles from './questionCard.module.scss';
import PromptOnlyQuestionCard from './PromptOnlyQuestionCard';
import {
  DrawingQuestionStudentAnswer,
  GridQuestionStudentAnswer,
  MultipleChoiceQuestionStudentAnswer,
  WritingQuestionStudentAnswer,
  FillInTheBlankQuestionStudentAnswer,
  ImageMultipleChoiceQuestionStudentAnswer,
  DragAndDropQuestionStudentAnswer,
} from '../StudentAnswers';

const STUDENT_ANSWER_COMPONENT_MAP = {
  DragAndDropQuestion: DragAndDropQuestionStudentAnswer,
  DrawingQuestion: DrawingQuestionStudentAnswer,
  FillInTheBlankQuestion: FillInTheBlankQuestionStudentAnswer,
  GridQuestion: GridQuestionStudentAnswer,
  ImageMultipleChoiceQuestion: ImageMultipleChoiceQuestionStudentAnswer,
  MultipleChoiceQuestion: MultipleChoiceQuestionStudentAnswer,
  OpenEndedQuestion: WritingQuestionStudentAnswer,
  // SliderQuestion: SliderQuestionStudentAnswer,
};

interface QuestionCardProps {
  question: IQuestion;
  questionAnswer?: IQuestionAnswer;
}

const QuestionCard = ({ question, questionAnswer }: QuestionCardProps) => {
  const { isQuestionMode } = useGradingStore();
  if (question.type === 'PromptOnly' && !isQuestionMode) {
    return <PromptOnlyQuestionCard question={question} />;
  }

  const StudentAnswer = () => {
    const Component = STUDENT_ANSWER_COMPONENT_MAP[question.type];
    if (Component) {
      return (
        <Component
          question={question}
          questionAnswer={questionAnswer}
        />
      );
    }

    return <div key={question.id}>{`${question.type} to add`}</div>;
  };

  const QuestionContent = () => (
    <div className={styles.bodyContent}>
      <div dangerouslySetInnerHTML={{ __html: question.sanitized_body }} />
    </div>
  );

  if (isQuestionMode) {
    return (
      <BaseQuestionModeCard question={question}>
        <QuestionContent />
      </BaseQuestionModeCard>
    );
  }

  return (
    <BaseCard
      key={question.id}
      question={question}
      questionAnswer={questionAnswer}
      studentAnswerHtml={<StudentAnswer />}
    >
      <QuestionContent />
    </BaseCard>
  );
};

export default QuestionCard;
